import { Col as AntCol } from "antd";

const Col = AntCol;

export default Col;
